import { render, staticRenderFns } from "./MetricGroupCard.vue?vue&type=template&id=d3645160&scoped=true"
import script from "./MetricGroupCard.vue?vue&type=script&lang=js"
export * from "./MetricGroupCard.vue?vue&type=script&lang=js"
import style0 from "./MetricGroupCard.vue?vue&type=style&index=0&id=d3645160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3645160",
  null
  
)

export default component.exports